<template>
  <div class="introForm">
    <Card :_expand="true" v-if="post">
      <template v-slot:title>Post Head</template>

      <template v-slot:content>
        <div class="introForm">
          <!-- title -->
          <div class="form-group mb-3">
            <div class="d-flex justify-content-between">
              <label> Title </label>

              <button
                class="btn btn-sm btn-default text-warning"
                data-toggle="popover"
                data-placement="left"
                data-content="Does it reflect the user intent? <br> Does it have the keyword? <br> Does it make you want to click?"
              >
                <i class="fad fa-lightbulb"></i>
              </button>
            </div>

            <input
              name="title"
              type="text"
              class="form-control"
              v-model="post.title"
              placeholder="Title"
              @input="handleValueUpdate"
              autocomplete="off"
            />
            <span v-if="!errors.title" class="text-info">
              <i class="fad fa-info-circle"></i>&nbsp; Character count:
              {{ post.title ? post.title.length : 0 }}, recommended: 57 or less
            </span>
            <span v-if="errors['title']" class="text-danger">
              <i class="fad fa-exclamation-circle"></i>&nbsp; {{ errors.title }}</span
            >
          </div>

          <div class="row mb-3">
            <div class="col">
              <!-- title html 1 -->
              <div class="form-group mb-3">
                <label>Title HTML 1</label>
                <input
                  type="text"
                  name="titleHtml1"
                  class="form-control"
                  v-model="post.titleHtml1"
                  placeholder="Title HTML 1"
                  @input="handleValueUpdate"
                />
                <span v-if="errors['titleHtml1']" class="text-danger">
                  <i class="fad fa-exclamation-circle"></i>&nbsp;
                  {{ errors.titleHtml1 }}</span
                >
                <span v-else>&nbsp;</span>
              </div>

              <!-- categories -->
              <div class="form-group mb-3">
                <label>Categories</label>

                <TagsInput
                  :placeHolder="'Input categories'"
                  @change="handleCatChange"
                  :data="post.categories"
                />

                <span v-if="!errors.categories" class="text-info">
                  <i class="fad fa-info-circle"></i>&nbsp;Only 1 category
                  recommended</span
                >
                <span v-if="errors['categories']" class="text-danger">
                  <i class="fad fa-exclamation-circle"></i>&nbsp;
                  {{ errors.categories }}</span
                >
              </div>

              <!-- tags -->
              <div class="form-group mb-3">
                <label>Tags</label>
                <TagsInput
                  :placeHolder="'Input tags'"
                  @change="handleTagsChange"
                  :data="post.tags"
                />

                <span v-if="!errors.tags" class="text-info"
                  ><i class="fad fa-info-circle"></i>&nbsp;3 tags are recommended</span
                >
                <span v-if="errors['tags']" class="text-danger">
                  <i class="fad fa-exclamation-circle"></i>&nbsp; {{ errors.tags }}</span
                >
              </div>

              <!-- description -->
              <div class="form-group mb-3">
                <div class="d-flex justify-content-between">
                  <label> Description </label>

                  <button
                    class="btn btn-sm btn-default text-warning"
                    data-toggle="popover"
                    data-placement="left"
                    data-content="Does it have the keyword? <br> Does it have a question? <br> Does it descirbe the content?"
                  >
                    <i class="fad fa-lightbulb"></i>
                  </button>
                </div>

                <textarea
                  name="description"
                  class="form-control"
                  v-model="post.description"
                  placeholder="Description"
                  rows="5"
                  @input="handleValueUpdate"
                ></textarea>
                <span v-if="post.description && !errors.description" class="text-info"
                  ><i class="fad fa-info-circle"></i>&nbsp;Character count:
                  {{ post.description.length }}, recommended: 155 or less</span
                >
                <span v-if="errors['description']" class="text-danger">
                  <i class="fad fa-exclamation-circle"></i>&nbsp;
                  {{ errors.description }}</span
                >
              </div>
            </div>

            <div class="col">
              <!-- title html 2 -->
              <div class="form-group mb-3">
                <label>Title HTML 2</label>
                <input
                  type="text"
                  name="titleHtml2"
                  class="form-control"
                  v-model="post.titleHtml2"
                  placeholder="Title HTML 2"
                  @input="handleValueUpdate"
                />
                <span v-if="errors['titleHtml2']" class="text-danger">
                  <i class="fad fa-exclamation-circle"></i>&nbsp;
                  {{ errors.titleHtml2 }}</span
                >
                <span v-else>&nbsp;</span>
              </div>

              <!-- thumbnails -->
              <div class="form-group mb-3">
                <div class="d-flex justify-content-between">
                  <label>Thumbnails</label>

                  <button
                    class="btn btn-sm btn-default text-warning"
                    data-toggle="popover"
                    data-placement="left"
                    data-content="Does reflect the content of the post? <br> Does it have the title? <br> Does it have the logo of the blog?"
                  >
                    <i class="fad fa-lightbulb"></i>
                  </button>
                </div>

                <div class="d-flex">
                  <ImageInput
                    :fileType="'verticalThumbnail'"
                    :error="errors['verticalThumbnail']"
                    @change="(data) => handleFileUpload('verticalThumbnail', data)"
                    :value="post.verticalThumbnail"
                  />

                  <ImageInput
                    :fileType="'horizontalThumbnail'"
                    :error="errors['horizontalThumbnail']"
                    @change="(data) => handleFileUpload('horizontalThumbnail', data)"
                    :value="post.horizontalThumbnail"
                  />
                </div>
              </div>

              <!-- Date -->
              <div class="form-group mb-3">
                <label>Date</label>
                <input
                  type="date"
                  name="date"
                  class="form-control"
                  v-model="post.date"
                  placeholder="Date"
                  @input="handleValueUpdate"
                />
              </div>

              <!-- URL -->
              <div class="form-group">
                <label>URL</label>
                <input
                  type="text"
                  name="url"
                  class="form-control"
                  v-model="post.url"
                  placeholder="URL"
                  @input="handleValueUpdate"
                />
                <span v-if="errors['url']" class="text-danger">
                  <i class="fad fa-exclamation-circle"></i>&nbsp; {{ errors.url }}</span
                >
                <span v-else>&nbsp;</span>
              </div>
            </div>
          </div>
        </div>
      </template>
    </Card>
    <div class="m-4"></div>
    <Card :_expand="true" v-if="post">
      <template v-slot:title>
        FAQs
        <br />
        <span>At least 3 FAQs recommended</span>
      </template>

      <template v-slot:content>
        <div class="d-flex flex-column">
          <div
            class="faq d-flex flex-column mb-2 p-2"
            v-for="(faq, index) in post.faqs"
            :key="index"
          >
            <div class="question d-flex w-100 mb-2">
              <div class="form-group w-100">
                <input
                  type="text"
                  class="form-control align-self-center"
                  placeholder="Question"
                  v-model="post.faqs[index].q"
                  @input="handleValueUpdate"
                />

                <span v-if="!errors['faqs[' + index + '].q']" class="text-info">
                  <i class="fad fa-info-circle"></i>&nbsp;Character count:
                  {{ post.faqs[index].q ? post.faqs[index].q.length : 0 }}, recommended:
                  57 or less recommended
                </span>
                <span v-if="errors['faqs[' + index + '].q']" class="text-danger">
                  <i class="fad fa-exclamation-circle"></i>&nbsp;
                  {{ errors["faqs[" + index + "].q"] }}
                </span>
              </div>

              <button
                type="button"
                class="btn btn-sm btn-default align-self-start"
                @click="removeFaq(index)"
              >
                <i class="fad fa-trash-alt"></i>
              </button>
            </div>

            <div class="form-group w-100">
              <textarea
                class="form-control align-self-center"
                placeholder="Answer"
                v-model="post.faqs[index].a"
                @input="handleValueUpdate"
              ></textarea>
              <span v-if="!errors['faqs[' + index + '].a']" class="text-info">
                <i class="fad fa-info-circle"></i>&nbsp;Character count:
                {{ post.faqs[index].a ? post.faqs[index].a.length : 0 }}, recommended: 155
                or less recommended
              </span>
              <span v-if="errors['faqs[' + index + '].a']" class="text-danger">
                <i class="fad fa-exclamation-circle"></i>&nbsp;
                {{ errors["faqs[" + index + "].a"] }}
              </span>
            </div>
          </div>

          <button
            type="button"
            class="btn btn-primary btn-sm align-self-start"
            @click="addfaq()"
          >
            <i class="fad fa-plus-circle"></i>
            &nbsp;
            <template v-if="post.faqs.length">Add another FAQ</template>
            <template v-else>Add FAQs</template>
          </button>
        </div>
      </template>
    </Card>
  </div>
</template>

<script>
import Card from "@/components/Card.vue";
import ImageInput from "@/components/ImageInput.vue";
import { validatePost } from "@/services/validation";
import TagsInput from "@/components/TagsInput";

export default {
  name: "PostForm",
  components: { Card, ImageInput, TagsInput },
  props: ["_post"],
  data() {
    return {
      post: null,
      saveTimer: null,
      errors: {},
    };
  },

  async created() {
    this.post = this._post;
    $(function () {
      $('[data-toggle="popover"]').popover({
        html: true,
        container: "body",
        trigger: "focus",
      });
    });

    // auto populate date if not exists
    if (!this.post.date) this.post.date = new Date().toISOString().substr(0, 10);

    this.handleValueUpdate();
  },

  methods: {
    handleCatChange(v) {
      this.post.categories = v;
      this.handleValueUpdate();
    },

    handleTagsChange(v) {
      this.post.tags = v;
      this.handleValueUpdate();
    },

    removeFaq(index) {
      this.post.faqs.splice(index, 1);
      this.handleValueUpdate();
    },

    addfaq() {
      this.post.faqs.push({ q: null, a: null });
      this.handleValueUpdate();
    },

    handleFileUpload(type, data) {
      this.post[type] = data;
      this.handleValueUpdate();
    },

    handleValueUpdate() {
      let { status, data } = validatePost(this.post);
      this.errors = {};
      if (!status) this.errors = data;

      // wait 500ms before emitting update
      clearTimeout(this.saveTimer);
      this.saveTimer = setTimeout(() => {
        this.$emit("change", {
          post: this.post,
          errorsCount: Object.keys(this.errors).length,
        });
      }, 500);
    },
  },
};
</script>

<style scoped lang="scss">
.introForm {
  label {
    font-weight: bold;
  }

  span {
    font-size: 0.7rem;
  }

  .faq {
    background-color: whitesmoke;
    border-radius: 0.25rem;
  }
}
</style>
